import React from 'react';
import { Icon, IconName, mainTheme } from '@plecto/ui';
import Badge from '../badge/Badge';
import styled from 'styled-components';

const PaneTitleRoot = styled.div`
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const PaneTitleText = styled.h5`
  flex: 1 auto;
  color: ${mainTheme.text.primary};
  font-size: 18px;
  font-weight: 400;
  line-height: 140%; /* 22.4px */
  margin: 0;
`;

const PaneTitleCloseIcon = styled(Icon)`
  color: ${mainTheme.slideIn.closeIcon.color};
  cursor: pointer;
  transition: color 0.13s;
  &:hover {
    color: ${mainTheme.slideIn.closeIcon.hover};
  }
`;

type PanelTitleProps = {
    title?: JSX.Element | string,
    badge?: string,
    onClose?: () => void,
    className?: string,
    icon?: IconName,
    blankMode?: boolean,
};

export function PaneTitle({ title, badge, onClose, blankMode }: PanelTitleProps) {
	const showTitle = title && !blankMode;
	return <PaneTitleRoot>
		{showTitle && <PaneTitleText>
			{title}{badge && <Badge label={badge} />}
		</PaneTitleText>}
		<PaneTitleCloseIcon icon={'x'} onClick={onClose} />
	</PaneTitleRoot>;
}
